"use strict";var videoPromise = [];

function load(src, cssSrc) {
  if (!videoPromise[src]) {
    videoPromise[src] = Promise.all([
    new Promise(function (resolve, reject) {
      var head = document.head || document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.src = src;

      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject();
        delete videoPromise[src];
      };
      head.appendChild(script);
    }),
    new Promise(function (resolve, reject) {
      var head = document.head || document.getElementsByTagName('head')[0];
      var cssnode = document.createElement('link');
      cssnode.type = 'text/css';
      cssnode.rel = 'stylesheet';

      cssnode.href = cssSrc;

      cssnode.onreadystatechange = function () {
        resolve();
      };

      cssnode.onload = function () {
        resolve();
      };
      cssnode.onerror = function () {
        reject();
        delete videoPromise[src];
      };
      head.appendChild(cssnode);
    })]);

  }
  return videoPromise[src];
}

module.exports = load;